import axios from "axios";
import Links from "../constants/Links";

/**
 * Matriculation-number change history.
 * Auth: ADMIN or SUPER_ADMIN.
 */
const MatricHistory = {
    /**
     * @description Paginated history of matric-number changes ordered by date DESC.
     * Optional case-insensitive substring `query` filters on oldReg, newReg, or
     * student userId.
     * @param {number} page zero-indexed page number
     * @param {number} size items per page (must be >= 1)
     * @param {string} [query] optional substring filter
     * @returns {Promise<AxiosResponse<*>>} Spring Page<MatriculationNumberHistoryResponse>
     */
    listPaginated: async (page, size, query) => {
        const params = { page, size }
        if (query) params.query = query
        return axios.get(Links.matricHistory.list, { params })
    },
}

export default MatricHistory
